<div [innerHTML]="secureIcon"></div>